interface Plan {
  years: number;
  months?: number;
}

export const getPlanDuration = (plan: Plan): string => {
  return plan.months ? `${plan?.years}.${plan.months}` : `${plan?.years}`;
};

export const isCashPayment = (
  downPayment: number | string | null,
  installment: number | string | null,
  isCash: boolean | null
): boolean => {
  return (
    isCash ||
    ((downPayment == 0 || downPayment == null) &&
      (installment == 0 || installment == null))
  );
};

export const determineSaleType = (
  isResale: boolean,
  isFinancing: boolean
): string => {
  if (!isResale && !isFinancing) {
    return 'Developer';
  }
  if (isResale && !isFinancing) {
    return 'Resale';
  }
  if (isResale && isFinancing) {
    return 'Nawy Now';
  }
  return 'Unknown';
};
